import client from "../libs/HttpClient";

class CareerServices {
  static careerList(request) {
    
    const page_no = request.queryKey[1];
    return client.get(`/careers?page=${page_no}`, request);
  }
  static addCareer(request) {
    return client.post(`/add-career`, request, {});
  }
  static updateCareer(request) {
    return client.post(`/update-career`, request, {});
  }
  static viewCareer(params) {
    return client.get(`/get-career`, { params });
  }
  static deleteCareer(params) {
    return client.delete(`/delete-career`, { params });
  }
  static updateStatusCareer(request) {
    return client.post(`/career-status`, request);
  }
  static fileDownload(request) {
    return client.get(`/get-file?filename=${request.filename}`, request);
  }
}

export { CareerServices };
